module.exports = __webpack_public_path__ + "resources/icon_32_close.68994cd07743ca38.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_close.png
// module id = 439
// module chunks = 0 1 2 3 4